import App from './UX.svelte';

const app = new App({
	target: document.body
});

export default app;